/**
 * MER-193: shared "coming soon" page for `/admin/*` routes that
 * have not been built yet. Each future child of MER-185 replaces
 * its route with a real page; this stub keeps the route tree
 * complete so navigation works end to end on day one.
 */

export interface AdminPlaceholderProps {
  /** Title shown as the page heading. Defaults to "Coming soon". */
  title?: string;
  /** Short description rendered under the title. */
  description?: string;
}

export default function AdminPlaceholder(props: AdminPlaceholderProps) {
  const { title = "Coming soon", description } = props;
  return (
    <main style={{ padding: "24px 32px" }}>
      <header
        style={{
          padding: "22px 28px",
          background: "linear-gradient(110deg, var(--brand-mint) 0%, #E6F3EE 50%, #FFFFFF 100%)",
          border: "1px solid var(--brand-line)",
          borderRadius: 8,
          marginBottom: 18,
        }}
      >
        <div
          style={{
            fontSize: 11,
            textTransform: "uppercase",
            letterSpacing: 1,
            color: "var(--text-2)",
            fontWeight: 700,
          }}
        >
          Admin
        </div>
        <h1
          style={{
            margin: "6px 0 0 0",
            fontSize: 26,
            fontWeight: 800,
            letterSpacing: -0.5,
            color: "var(--text)",
          }}
        >
          {title}
        </h1>
      </header>
      <div
        style={{
          background: "var(--bg-card)",
          border: "1px solid var(--border-subtle)",
          borderRadius: 12,
          padding: "28px",
          color: "var(--text-2)",
          fontSize: 14,
          lineHeight: 1.5,
        }}
      >
        {description ?? "This page is on the way. Check back soon."}
      </div>
    </main>
  );
}
